import { Components, Theme } from '@mui/material'

export const MuiDialogContent: Components<Omit<Theme, 'components'>>['MuiDialogContent'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      paddingLeft: 24,
      paddingRight: 24,
      display: 'flex',
      flexDirection: 'column',
    },
  },
}
